//import React from 'react';
import DatePicker from 'react-date-picker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import styled from 'styled-components';
import { fontFamily } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

import { Box } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label, Span } from '../../../typography';
import { ErrorMessage } from 'formik';

const DatePickerWrapper = styled.div<StyledSystemProps>`
  width: 100%;
  .react-date-picker,
  .react-daterange-picker {
    background-color: #fff;
    height: 40px;
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
  }
  .react-date-picker > .react-date-picker__wrapper,
  .react-daterange-picker > .react-daterange-picker__wrapper {
    border-radius: 4px;
    border: 1px solid rgba(50, 50, 93, 0.2);
  }
  .react-calendar {
    border: 1px solid rgba(50, 50, 93, 0.2);
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
    ${fontFamily};
    padding: 10px;
  }
  /* Elevate only the open popup above sibling fields — not the whole field box,
     which would otherwise permanently sit above unrelated dropdowns nearby. */
  .react-date-picker__calendar,
  .react-daterange-picker__calendar {
    z-index: 100;
  }
`;

const DatePickerWithFormik = ({
  isSingleDate,
  clearIcon,
  date,
  dateLabel,
  endDate,
  endDateId,
  endDateLabel,
  maxDate,
  minDate,
  readOnly,
  showLeadingZeros,
  startDate,
  startDateId,
  startDateLabel,
  form: { setFieldValue },
  label,
  changeHandler,
  format,
  zIndex,
  ...rest
}: any) => {
  return (
    <Box {...rest}>
      {label && <Label htmlFor={isSingleDate ? dateLabel : startDateLabel}>{label}</Label>}
      <DatePickerWrapper>
        {isSingleDate ? (
          <DatePicker
            showLeadingZeros={showLeadingZeros}
            clearIcon={clearIcon}
            format={format}
            minDate={minDate}
            maxDate={maxDate}
            disabled={readOnly}
            value={date ? date : null}
            onChange={(date: any) => {
              setFieldValue(dateLabel, date);
              if (changeHandler) changeHandler(date);
            }}
          />
        ) : (
          <DateRangePicker
            disabled={readOnly}
            value={[startDate, endDate]}
            format={format}
            onChange={(data: any) => {
              const startDate = data && data.length === 2 ? data[0] : null;
              const endDate = data && data.length === 2 ? data[1] : null;
              setFieldValue(startDateLabel, startDate);
              setFieldValue(endDateLabel, endDate);
              if (changeHandler) changeHandler(startDate, endDate);
            }}
          />
        )}
      </DatePickerWrapper>
      <ErrorMessage name={isSingleDate ? dateLabel : startDateLabel}>
        {msg => (
          <Span mt={2} color="red" textAlign="right">
            {msg}
          </Span>
        )}
      </ErrorMessage>
    </Box>
  );
};

DatePickerWithFormik.defaultProps = {
  mb: 4,
  flex: 1,
  minWidth: '150px',
};

export default DatePickerWithFormik;
